import { render, staticRenderFns } from "./RSFolderTree.vue?vue&type=template&id=9b4820c0&scoped=true&"
import script from "./RSFolderTree.vue?vue&type=script&lang=js&"
export * from "./RSFolderTree.vue?vue&type=script&lang=js&"
import style0 from "./RSFolderTree.vue?vue&type=style&index=0&id=9b4820c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4820c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b4820c0')) {
      api.createRecord('9b4820c0', component.options)
    } else {
      api.reload('9b4820c0', component.options)
    }
    module.hot.accept("./RSFolderTree.vue?vue&type=template&id=9b4820c0&scoped=true&", function () {
      api.rerender('9b4820c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/repository-selector/RSFolderTree.vue"
export default component.exports